var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingButtonBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8622 10.0198C26.4536 10.3062 29.2265 10.9175 30.6873 11.078C33.9082 11.4004 34.7373 11.5317 34.9492 10.4905C35.3887 9.32651 33.1698 8.55873 30.4947 7.65744C27.2582 6.65929 23.9183 6.03443 20.5399 5.795C19.731 5.7769 16.7098 6.03343 16.7074 7.35217C16.6094 9.04517 21.9091 9.38074 24.8622 10.0198Z",
    fill: "#09534A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7292 18.0487C15.3632 18.9516 19.4533 23.1027 19.9997 23.5927C22.0555 25.3329 23.591 26.7825 24.5024 25.9734C25.9823 24.8062 21.6665 20.2414 20.5395 18.9923C19.9055 18.3179 17.9007 16.2286 17.1695 15.6668C16.8508 15.4186 14.6737 13.881 13.8539 14.6113C13.034 15.3416 14.4764 17.6862 14.7292 18.0487Z",
    fill: "#09534A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84206 25.228C6.08606 26.4394 7.0705 30.1082 7.46854 31.3968C7.71753 32.3821 8.02355 33.352 8.38508 34.3018C9.65616 37.1963 10.2088 38.1724 11.1719 37.8546C12.2024 37.548 12.0033 36.1824 11.5664 33.9275C11.013 30.4851 10.1578 27.098 9.01074 23.8055C8.87332 23.431 7.57591 20.7705 6.42322 21.113C5.11757 21.4966 5.79175 24.622 5.84206 25.228Z",
    fill: "#09534A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingButtonBottomRight);
export default __webpack_public_path__ + "static/media/onboardingButtonBottomRight.61c075a77e0bfbcc044c7b2340999e10.svg";
export { ForwardRef as ReactComponent };